export default __webpack_public_path__ + "static/media/mini-trash-icon.c1ada63c.svg";